// ============================================================
// SocialMedia.js
// ============================================================
import React, { useEffect, useState } from 'react';
import { useApi } from '../hooks/useApi';
import { useAuth } from '../context/AuthContext';
import { Save, ExternalLink } from 'lucide-react';
import toast from 'react-hot-toast';


export function SocialMedia() {
  const api = useApi();
  const { can } = useAuth();
  const [settings, setSettings] = useState({
    social_youtube: '',
    social_facebook: '',
    social_tiktok: '',
    social_whatsapp: '',
    social_instagram: '',
    social_twitter: ''
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => { load(); }, []);
  async function load() {
    setLoading(true);
    const s = await api.get('/social-settings');
    if (s?.settings) setSettings(p => ({ ...p, ...s.settings }));
    setLoading(false);
  }
  async function save() {
    setSaving(true);
    const d = await api.post('/social-settings', { updates: settings });
    if (d?.success) toast.success('Social media links save ho gaye!'); else toast.error(d?.error || 'Error');
    setSaving(false);
  }

  const PLATFORMS = [
    { key: 'social_youtube',   label: '▶️ YouTube',         placeholder: 'https://youtube.com/@channel' },
    { key: 'social_facebook',  label: '📘 Facebook',         placeholder: 'https://facebook.com/page' },
    { key: 'social_tiktok',    label: '🎵 TikTok',           placeholder: 'https://tiktok.com/@user' },
    { key: 'social_whatsapp',  label: '💬 WhatsApp Channel', placeholder: 'https://whatsapp.com/channel/...' },
    { key: 'social_instagram', label: '📸 Instagram',        placeholder: 'https://instagram.com/user' },
    { key: 'social_twitter',   label: '🐦 X (Twitter)',      placeholder: 'https://x.com/user' },
  ];

  if (loading) return <div style={{ textAlign: 'center', padding: 60 }}><span className="spinner" style={{ width: 32, height: 32 }} /></div>;

  return (
    <div className="page">
      <div className="page-header">
        <div className="section-title">📱 Social Media</div>
        <div className="section-sub">Bot mein dikhne wale social media links manage karein</div>
      </div>

      <div style={{ maxWidth: 560 }}>
        <div className="card">
          {PLATFORMS.map(({ key, label, placeholder }) => (
            <div key={key} className="field">
              <label className="label">{label}</label>
              <div style={{ display: 'flex', gap: 8 }}>
                <input
                  className="input"
                  value={settings[key] || ''}
                  onChange={e => setSettings(p => ({ ...p, [key]: e.target.value }))}
                  disabled={!can('settings')}
                  placeholder={placeholder}
                  style={{ flex: 1 }}
                />
                {settings[key] && (
                  <a href={settings[key]} target="_blank" rel="noreferrer"
                    style={{ display: 'flex', alignItems: 'center', padding: '0 10px', background: 'var(--emerald-900)', border: '1px solid var(--emerald-700)', borderRadius: 8, color: 'var(--emerald-300)' }}>
                    <ExternalLink size={13} />
                  </a>
                )}
              </div>
            </div>
          ))}

          {can('settings') && (
            <div style={{ marginTop: 8 }}>
              <button className="btn btn-primary" onClick={save} disabled={saving}>
                {saving ? <span className="spinner" style={{ width: 14, height: 14 }} /> : <Save size={14} />}
                {saving ? ' Saving...' : ' Save Karein'}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default SocialMedia;